//react/redux
import { AiFillCheckCircle } from "react-icons/ai";
import { datadogLogs } from "@datadog/browser-logs";
import { RiEmotionHappyLine } from "react-icons/ri";

//components
import Header from "../Common/header";
import { useEffect } from "react";

const Success = ({
  tenantColor,
  tenantImage,
  tenantName,
  responseScan,
  redirect,
  redirectUrl,
}) => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const token = urlSearchParams.get("token");
  datadogLogs.logger.info(
    `Process completed with the invitationId: ${responseScan?.invitation_id}`,
    {
      invitationId: responseScan?.invitation_id,
      tenantName: tenantName,
      //url: responsePayload?.ScanProcess?.url,
    },
  );

  useEffect(() => {
    setTimeout(() => {
      if (redirect === true) {
        window.location.href = `/setup?token=${token}`;
      } else if (redirectUrl) {
        datadogLogs.logger.info(
          `Redirecting to client redirect_url with the invitationId: ${responseScan?.invitation_id}`,
          {
            invitationId: responseScan?.invitation_id,
            tenantName: tenantName,
            redirectUrl: redirectUrl,
          },
        );
        window.location.href = redirectUrl;
      }
    }, 7000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <section className="container mx-auto flex flex-col items-center justify-start gap-5">
        <Header
          responseScan={responseScan}
          tenantColor={tenantColor}
          tenantImage={tenantImage}
          tenantName={tenantName}
        />
        <div className="px-4 py-24 flex flex-col justify-center items-center gap-4 my-3">
          {redirect ? (
            <RiEmotionHappyLine size={120} className="" color={tenantColor} />
          ) : (
            <AiFillCheckCircle size={120} className="text-[#1DB83F]" />
          )}
          <h2 className="text-2xl">Done!</h2>
          {redirect ? (
            <p className="text-center text-sm">
              Your authentication has been successfully completed. You will be
              redirected shortly to the options page to continue.
            </p>
          ) : redirectUrl ? (
            <p className="text-center text-sm">
              The authentication process is now complete. You will be
              redirected shortly.
            </p>
          ) : (
            <>
              <p className="text-center text-sm">
                The authentication process is now complete. We will contact you
                if we have any questions about your authentication results.
              </p>
              <p className="text-center text-sm">You may close this tab.</p>
            </>
          )}
        </div>
      </section>
    </>
  );
};

export default Success;
